import React, { useEffect, useState } from "react";
import { Modal, Container, Toast } from "react-bootstrap";
import { getCedula } from "utils/DatosUsuarioLocalStorag";
import { Host } from "utils/constantes";
import axios from "axios";
import { DatosUsuariocliente } from "utils/constantes";
import logo from "../../../../assets/imagen/logo-inicio.png";
import { useSelector, useDispatch } from "react-redux";
import { addususcritor } from "StoreRedux/Slice/SuscritorSlice";
import { setModal } from "StoreRedux/Slice/SuscritorSlice";
import { setToastes } from "StoreRedux/Slice/ToastSlice";
import { DatosUsuarioLocalStorang } from "utils/constantes";
import { Boleteria_password } from "utils/EventosQuery/index";

import ReactGA from 'react-ga4';
import { logWithCallback } from "utilsstile.js/style";
const TRACKING_ID = "G-LJN507B5NX";
const ModalLogin = (props) => {
  useEffect(() => { ReactGA.initialize(TRACKING_ID, { standardImplementation: true }); }, []);
  const { showLogin, setShowLogin, abrir } = props
  let Modalstatus = useSelector((state) => state.SuscritorSlice.modal)
  const usedispatch = useDispatch()
  const [message, setmessage] = useState("");
  const [show, setShowToas] = useState(false);
  const [showtoass, setShowToass] = useState(false);
  const [credenciales, setnombre] = useState({ username: '', pass: '', });
  const [ingresando, setIngresando] = useState(false)
  const [tipo, setTipo] = useState(true)
  const handleSubmit = async (event) => {
    var hoy = new Date();
    event.preventDefault();
    if (credenciales.username !== '' && credenciales.pass !== '') {

      try {
        setIngresando(true)
        let randon = sessionStorage.getItem("random")
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/auth_suscriptor", { email: credenciales.username.trim(), password: credenciales.pass.trim() }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
          }
        })
        if (data.success) {
          const cedula = await getCedula(data.data.cedula)
          let client = {
            cedula: data.data.cedula, direccion: data.data.ciudad, whatsapp: data.data.movil,
            telefono: data.data.movil, name: data.data.nombreCompleto,
            email: data.data.email, hora: String(hoy),
            enable: data.data.enable, id: data.data.id,
            discapacidad: 'No',
            envio: ''
          }
          sessionStorage.setItem(DatosUsuariocliente, JSON.stringify(client))
          sessionStorage.setItem(DatosUsuarioLocalStorang, JSON.stringify(client))
          usedispatch(addususcritor({ ...client }))
          ReactGA.event({
            category: "" + data.data.cedula,
            action: "login",
            label: "click",
            method: "email",
            'userId': data.data.cedula,
          })
          usedispatch(setToastes({
            show: true,
            message: "Bienvenido " + data.data.nombreCompleto,
            color: 'bg-success',
            estado: "Inicio Exitoso",
          }))
          setTimeout(() => {
            Modalstatus.estado == "" ? window.location.reload() : ""
          }, 2000);


          Modalstatus.estado != "" ? usedispatch(setModal({ nombre: Modalstatus.estado == null ? "" : 'ModalDetalle', estado: '' })) : usedispatch(setModal({ nombre: "", estado: '' }))
          if (randon) {
            axios.post("https://api.t-ickets.com/ms_login/api/v1/actulizar_identificacion_asiento",
              {
                "random": randon,
                "cedula": data.data.cedula
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                }
              }
            ).then(e => {
              logWithCallback(e)
            }).catch(err => {
              logWithCallback(err)
            })
          }
        }
        else {
          usedispatch(setToastes({
            show: true,
            message: "Hubo un error Verifique correo y contraseña e intente de nuevo",
            color: 'bg-danger',
            estado: "Hubo un error",
          }))
        }
      } catch (error) {
        logWithCallback(error)
        usedispatch(setToastes({
          show: true,
          message: "Hubo un error Verifique correo y contraseña e intente de nuevo",
          color: 'bg-danger',
          estado: "Hubo un error",
        }))
      } finally {
        setIngresando(false)
      }

    }
  };
  function RecuperarContraseña() {
    usedispatch(setModal({ nombre: '', estado: '' }))

    $.confirm({
      title: 'Recuperar Contraseña!',
      content: '' +
        '<form action="" className="formName">' +
        '<div className="form-group">' +
        '<label>Ingrese su número de cédula</label>' +
        '<input type="text" placeholder="cédula" class="form-control codigo " required />' +
        '</div>' +
        '</form>',
      buttons: {
        formSubmit: {
          text: 'Enviar',
          btnClass: 'btn-blue',
          action: function () {
            var name = this.$content.find('.codigo').val();
            if (!name) {
              $.alert('Ingrese un correo validso');
              return false;
            }
            Boleteria_password(name).then(e => {
              if (e.estado) {

                usedispatch(setToastes({
                  show: true,
                  message: "Tienes 30 minutos para restablecer tu contraseña ",
                  color: 'bg-success',
                  estado: "Solicitud enviada",
                }))
              } else {
                usedispatch(setToastes({
                  show: true,
                  message: "su perfil no existe o no resgistro numero de telefono",
                  color: 'bg-danger',
                  estado: "Solicitud no enviada",
                }))
              }
            })
          }
        },
        cancel: function () {

        }
      }
    })
  }
  function regsitronew() {
    setShowLogin(false)
    usedispatch(setModal({ nombre: 'registro', estado: Modalstatus.estado }))
  }
  const handleChange = (target) => {
    const { name, value } = target
    setnombre({
      ...credenciales,
      [name]: value
    })
  }
  useEffect(() => {
  }, [Modalstatus.nombre == "loginpage" ? true : false])

  return (
    <div>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        show={Modalstatus.nombre == "loginpage" ? true : false}
        onHide={() => setShowLogin(false)}
        fullscreen={"md-down"}
        centered
      >
        <Modal.Header className="py-4  bg-dark ">
          <div className=" d-flex  col-12 ">
            <div className="col-sm   justify-content-end  pl-0 ">
              <h5 className="modal-title text-center">INICIA SESIÓN</h5>
            </div>

            <button type="button" className="close "
              onClick={() => Modalstatus.estado == "e" ? usedispatch(setModal({ nombre: 'formasPago', estado: Modalstatus.estado })) : usedispatch(setModal({ nombre: '', estado: '' }))}>
              ×
            </button>
          </div>
        </Modal.Header>
        <Modal.Body className="d-flex   align-items-center">
          <Container className="d-flex flex-column justify-content-center">
            <div className="card-body">
              <div className="container text-center">
                <img src={logo} className="mb-4 img-fluid " style={{ height: '125px', color: 'black' }} alt="" />
              </div>
              <form onSubmit={(e) => handleSubmit(e)}  >
                <div className="input-group mb-4">
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                  </div>
                  <input id="username" type="text" className="form-control"
                    name="username"
                    value={credenciales.username}
                    onChange={(e) => handleChange(e.target)}
                    required
                    placeholder="Usuario" />
                </div>
                <div className="input-group mb-4">
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="fa fa-lock"></i></span>
                  </div>
                  <input id="pass" type={tipo ? "password" : ""} className="form-control"
                    name="pass"
                    value={credenciales.pass}
                    required
                    onChange={(e) => handleChange(e.target)}
                    placeholder="Contraseña" />
                  <div className="input-group-prepend">
                    <span className="input-group-text " onClick={() => setTipo(!tipo)}><i className={!tipo ? "fa fa-eye" : "fa fa-eye-slash"}></i></span>
                  </div>
                </div>
                <div className="row text-center">
                  <div className="col-12">
                    <button className="btn btn-primary px-4" type="submit" disabled={ingresando}>
                      {ingresando ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          INGRESANDO...
                        </>
                      ) : "INGRESAR"}
                    </button>
                  </div>
                  <div className="col-12 "
                  >
                    <a className="btn btn-link text-pag  px-4" onClick={regsitronew} href="#"
                      style={{
                        fontWeight: "bold",
                        color: "#3F40E0"
                      }}
                    >Crear Cuenta</a>
                  </div>
                  <div className="col-12 ">
                    {/**onClick={RecuperarContraseña} */}
                    <a className=" nav-link btn btn-link" onClick={RecuperarContraseña} > Olvide mi contraseña </a>

                  </div>
                </div>
              </form>
            </div>
          </Container>
        </Modal.Body>
      </Modal>
      <Toast
        onClose={() => setShowToas(false)} show={show} delay={4000} autohide
        className="top-center"
        style={{
          position: 'fixed',
          top: 30,
          right: 2,
          transform: 'translate(-50 %, 0 %)',
          zIndex: 10000,
        }}>
        <Toast.Header closeButton={false}>
          <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
          <strong className="mr-auto">Hubo un error </strong>
          <small></small>
          <button type="button" className="close"
            onClick={() => setShowToas(false)} >
            ×
          </button>
        </Toast.Header>
        <Toast.Body className="bg-danger text-white" >{message} </Toast.Body>
      </Toast>

      <Toast
        onClose={() => setShowToass(false)} show={showtoass} delay={3500} autohide
        className="top-center"
        style={{
          position: 'fixed',
          top: 30,
          right: 2,
          transform: 'translate(-50 %, 0 %)',
          zIndex: 10000,
        }}>
        <Toast.Header closeButton={false} >
          <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
          <strong className="mr-auto">Inicio Exitoso </strong>
          <small></small>

          <button type="button" className="close"
            onClose={() => setShowToass(false)} >
            ×
          </button>
        </Toast.Header>
        <Toast.Body className="bg-success text-white" >   {message} </Toast.Body>
      </Toast>
    </div>
  )

}

export default ModalLogin;